import { FC } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';

const Hero: FC = () => {
  return (
    <HeroSection>
      <div className="container">
        <HeroContainer>
          <LeftColumn>
            <ProfileImageWrapper>
              <ProfileImage>
                <img src="/images/profilepic.jpg" alt="Matt Barbour" />
              </ProfileImage>
            </ProfileImageWrapper>
            <ContactGrid>
              <ContactItem href="https://www.linkedin.com/in/matt-barbour-700bb57" target="_blank" rel="noopener noreferrer">
                <ContactIcon>
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </ContactIcon>
                <ContactLabel>LinkedIn</ContactLabel>
              </ContactItem>

              <ContactItem href="https://github.com/barbourshop" target="_blank" rel="noopener noreferrer">
                <ContactIcon>
                  <FontAwesomeIcon icon={faGithub} />
                </ContactIcon>
                <ContactLabel>@barbourshop</ContactLabel>
              </ContactItem>
            </ContactGrid>
          </LeftColumn>
          <ContentWrapper>
            <HeroContent>
              <HeroTitle>Matt Barbour</HeroTitle>
              <HeroSubtitle>Software &amp; Woodworking</HeroSubtitle>
              <HeroText>
                This is where I collect what I’m making: shipped products and smaller experiments on the web, plus woodworking and other hands-on builds. Below you’ll find live demos and source for software, and photos with write-ups for the physical projects.
              </HeroText>
            </HeroContent>
          </ContentWrapper>
        </HeroContainer>
      </div>
    </HeroSection>
  );
};

const HeroSection = styled.div`
  padding: 50px 0 20px 0;
  background-color: #ffffff;
`;

const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  flex: 0 0 auto;
  width: 200px;
`;

const ProfileImageWrapper = styled.div`
  flex: 0 0 auto;
  width: 200px;
  margin: 0 auto;
`;

const ProfileImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  max-width: 800px;
`;

const HeroContent = styled.div`
  margin-bottom: 2rem;
`;

const HeroTitle = styled.h1`
  font-family: var(--font-primary);
  font-size: 3rem;
  color: #2c3e50;
  margin-bottom: 1rem;
`;

const HeroSubtitle = styled.p`
  font-family: var(--font-primary);
  font-size: 1.5rem;
  color: #3498db;
  margin-bottom: 1.5rem;
`;

const HeroText = styled.p`
  font-family: var(--font-primary);
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  color: #666;
`;

const ContactGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 100%;
`;

const ContactItem = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  transition: transform 0.3s ease;
  font-size: 0.75rem;
  text-decoration: none;

  &:hover {
    transform: translateY(-2px);
    background-color: #e9ecef;
  }
`;

const ContactIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6c757d;
  color: white;
  border-radius: 50%;
  flex-shrink: 0;
`;

const ContactLabel = styled.span`
  font-size: 0.75rem;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
`;

export default Hero;
